import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import PlusIcon from "@redotech/redo-icons/plus.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { NewMessageModal } from "@redotech/redo-merchant-support-app/new-message-modal";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ActiveConversationFilters } from "../filters/active-conversation-filters";
import { ConversationsFilterToolbar } from "../filters/conversations-filter-toolbar";
import { ConversationsTable } from "../table/components/conversations-table";

export const ConversationsTableView = memo(function ConversationsTableView() {
  const navigate = useNavigate();
  const team = useRequiredContext(TeamContext);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleNavigateAfterCreate = useHandler(
    async ({ conversationId }: { conversationId: string }) => {
      navigate(`/stores/${team._id}/support-v2/${conversationId}`);
    },
  );

  return (
    <Flex
      className="h-full w-full"
      dir="column"
      gap="xl"
      overflow="hidden"
      p="lg"
    >
      <Flex dir="column" gap="xl">
        <Flex align="center" justify="space-between">
          <ConversationsFilterToolbar />
          <RedoButton
            hierarchy="primary"
            IconLeading={PlusIcon}
            onClick={() => setCreateModalOpen(true)}
            text="Create new ticket"
          />
        </Flex>
        <ActiveConversationFilters />
      </Flex>
      <ConversationsTable maxHeight="calc(100vh - 270px)" />
      <NewMessageModal
        handleNavigate={handleNavigateAfterCreate}
        open={createModalOpen}
        setOpen={setCreateModalOpen}
      />
    </Flex>
  );
});
